function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["arrow", "as", "children", "className", "external", "onClick", "inverse", "icon", "iconPosition", "underline", "variation", "size", "weight"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { forwardRef, useMemo } from 'react';
import { ChevronLeft, ChevronRight } from "../Icon";
import { useInverse } from "../BackgroundProvider";
import Text from "../Text";
import StyledLink from "./styled";
import { useTheme } from 'styled-components';

/**
 * Documentation:
 *
 * - [Link for Windows (On-prem)](https://pages.ghe.service.group/constellation/docs/components/link)
 **/
var Link = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _classnames;
  var arrow = _ref.arrow,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'a' : _ref$as,
    children = _ref.children,
    className = _ref.className,
    external = _ref.external,
    onClick = _ref.onClick,
    inverseProp = _ref.inverse,
    iconProp = _ref.icon,
    iconPosition = _ref.iconPosition,
    _ref$underline = _ref.underline,
    underline = _ref$underline === void 0 ? true : _ref$underline,
    variation = _ref.variation,
    _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? 's2' : _ref$size,
    _ref$weight = _ref.weight,
    weightProp = _ref$weight === void 0 ? 'normal' : _ref$weight,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme() || {};
  var inverse = inverseProp !== undefined ? inverseProp : useInverse(theme);
  var size = sizeProp;
  var weight = weightProp;
  if (arrow) {
    console.warn('The `arrow` prop on `Link` component is deprecated. Please ' + 'use `iconPosition` prop to give the link an icon.');
  }
  if (variation) {
    console.warn('The `variation` prop on `Link` component is deprecated. Please ' + 'use `size` prop to specify font size, `weight` prop to specify font weight.');
  }
  if (variation === 'large' || variation === 'large-emphasized' || variation === 'intro') {
    size = 's3';
  }
  if (variation === 'normal' || variation === 'normal-emphasized' || variation === 'static') {
    size = 's2';
  }
  if (variation === 'small' || variation === 'small-emphasized') {
    size = 's1';
  }
  if (variation === 'small-emphasized' || variation === 'normal-emphasized' || variation === 'large-emphasized') {
    weight = 'bold';
  }
  var classNames = classnames('csl-link', (_classnames = {}, _defineProperty(_classnames, "csl-link--icon-".concat(iconPosition || arrow), iconPosition || arrow), _defineProperty(_classnames, 'csl-link--inverse', inverse), _classnames), className);
  var externalProps = external ? {
    rel: 'noopener noreferrer',
    target: '_blank'
  } : {};
  var icon = useMemo(function () {
    if (!iconProp && iconPosition === 'left' || arrow === 'left') {
      return /*#__PURE__*/React.createElement(ChevronLeft, {
        size: size,
        trim: true
      });
    }
    if (!iconProp && iconPosition === 'right' || arrow === 'right') {
      return /*#__PURE__*/React.createElement(ChevronRight, {
        size: size,
        trim: true
      });
    }
    return iconProp;
  }, [arrow, iconPosition, iconProp, size]);
  var onKeyDown = rest.onKeyDown || function (e) {
    var keyD = e.key !== undefined ? e.key : e.keyCode;
    if (!onClick) return;
    if (keyD === 'Enter' || keyD === 13) return onClick(e);
    if (['Spacebar', ' '].includes(keyD) || keyD === 32) return onClick(e);
  };
  return /*#__PURE__*/React.createElement(StyledLink, _extends({
    $underline: underline,
    as: as
  }, externalProps, {
    onClick: onClick,
    onKeyDown: onKeyDown,
    ref: ref,
    tabIndex: 0
  }, rest, {
    className: classNames
  }), /*#__PURE__*/React.createElement(Text, {
    color: "inherit",
    size: size,
    weight: weight
  }, (iconPosition === 'left' || arrow === 'left') && icon, /*#__PURE__*/React.createElement("span", {
    className: "csl-link__children"
  }, children), (iconPosition === 'right' || arrow === 'right') && icon));
});
Link.displayName = 'Link';
export default Link;